import axios from 'axios';
import config from '../../config';
import {
  goTo,
} from '../../actions/routing';
import {
  formatFormData,
} from '../../utils/formData';

export const ON_HIDE_ALERT = 'ON_HIDE_ALERT';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const RESET_FAIL = 'RESET_FAIL';
const SUBMIT_PENDING = 'SUBMIT_PENDING';
const SERVER_REQUEST_PENDING = 'myaxa/forgetPW/SERVER_REQUEST_PENDING';
const SERVER_REQUEST_COMPLETE = 'myaxa/forgetPW/SERVER_REQUEST_COMPLETE';

const initialState = {
  method: 'email',
  showAlert: false,
  password: '',
  verifyTokenComplete: false,
  isResetSuccess: false,
  serverStatus: '',
  previousIndividualForgetPassPath: '',
  isSubmitting: false,
  isLoading: false,
  errorCode: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ON_HIDE_ALERT:
      return {
        ...state,
        showAlert: false,
      };
    case RESET_SUCCESS:
      return {
        ...state,
        isResetSuccess: true,
        isSubmitting: false,
      };
    case RESET_FAIL:
      return {
        ...state,
        isResetSuccess: false,
        isSubmitting: false,
        showAlert: action.showAlert,
        errorCode: action.errorCode,
      };
    case SUBMIT_PENDING:
      return {
        ...state,
        isSubmitting: true,
      };
    case SERVER_REQUEST_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case SERVER_REQUEST_COMPLETE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const sendResetToken = (submitValues) => {
  return async (dispatch, getState) => {
    const details = {
      'contactType': submitValues.type,
      'countryCode': submitValues.countryCode,
      'mobile': submitValues.mobile,
      'email': submitValues.email,
      'locale': submitValues.locale,
      'analyticsId': submitValues.analyticsID,
    };

    const formData = formatFormData(details);

    dispatch({
      type: SUBMIT_PENDING,
    });

    dispatch({
      type: SERVER_REQUEST_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/password/forget`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(() => {
      dispatch({
        type: SERVER_REQUEST_COMPLETE,
      });
      dispatch({
        type: RESET_SUCCESS,
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/password/sent`));
    }).catch((error) => {
      dispatch({
        type: SERVER_REQUEST_COMPLETE,
      });
      if (error.response) {
        dispatch({
          type: RESET_FAIL,
          showAlert: true,
          errorCode: error.response.data.code,
        });
      } else {
        dispatch({
          type: RESET_FAIL,
          showAlert: true,
          errorCode: 'NETWORK',
        });
      }
    });
  };
};

export const submitResetPassword = (submitValues) => {
  return async (dispatch, getState) => {
    const details = {
      'axaId': submitValues.axaId,
      'token': submitValues.token,
      'password': submitValues.password,
      'locale': submitValues.locale,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SUBMIT_PENDING,
    });

    dispatch({
      type: SERVER_REQUEST_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/password/forget/verify`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(() => {
      dispatch({
        type: SERVER_REQUEST_COMPLETE,
      });
      dispatch({
        type: RESET_SUCCESS,
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/password/reset-success`));
    }).catch((error) => {
      dispatch({
        type: SERVER_REQUEST_COMPLETE,
      });
      if (error.response) {
        dispatch({
          type: RESET_FAIL,
          showAlert: true,
          errorCode: error.response.data.code,
        });
      } else {
        dispatch({
          type: RESET_FAIL,
          showAlert: true,
          errorCode: 'NETWORK',
        });
      }
    });
  };
};

export const modalClose = () => {
  return (dispatch) => {
    dispatch({
      type: ON_HIDE_ALERT,
    });
  };
};
